import React from 'react'
import { Button, Col, FormGroup, Input, InputGroup, InputGroupAddon, InputGroupText, Label, Row, Table, Pagination } from 'reactstrap'
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';



export const TableAgreement = (props) => {

    const {
        handleChangeRange, handleChangePercentage, handleDeleteRange, handleAddRange,
        list_agrement_test, handleDeleteTest, handleChangePrice,
        number_format, handleCant, check_sanitary, is_micro,
        goNextPage, goPreviousPage, totalPages, actualPage, goToPage,
        prevPage, nextPage, totalRecords, resultCount,
        handleTest, id_agreement, handleDeleteTestCreate
    } = props;

    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "12px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "12px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const labelStyle = {
        fontWeight: 600,
        fontSize: "12px",
        minHeight: "18px",
        lineHeight: "18px",
        textAlign: "center"
    };

    const amountStyle = {
        fontWeight: 700,
        fontSize: "12px",
        color: "#0d3b59",
        height: "31px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    };

    const inputStyle = {
        fontWeight: 700,
        fontSize: "12px",
        color: "#0d3b59",
        textAlign: "center"
    };


    console.log("🚀 ~ TableAgreement ~ list_agrement_test:", list_agrement_test)



    return (

        <DataTable
            value={list_agrement_test}
            lazy
            paginator
            first={(actualPage - 1) * 10}
            rows={10}
            totalRecords={totalRecords}
            onPage={(e) => goToPage(e.page + 1)}
            responsiveLayout="scroll"
            className="p-datatable-striped p-datatable-sm "
            emptyMessage="No se encontraron registros"
        >
            <Column
                field="code"
                header="Código"
                headerStyle={headerStyle}
                style={{
                    ...cellStyle,
                    width: "90px",
                    textAlign: "center"
                }}
                body={(rowData) => (
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "6px"
                        }}
                    >
                        {!rowData.id_agreement_test && (
                            <div
                                style={{
                                    width: "30px",
                                    height: "30px",
                                    borderRadius: "50%",
                                    backgroundColor: "#f97316",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "#fff",
                                    flexShrink: 0
                                }}
                            >

                                <i
                                    className="icofont icofont-laboratory f-14"
                                    style={{
                                        fontSize: "12px"
                                    }}
                                />
                            </div>
                        )}

                        <span>{rowData.code}</span>
                    </div>
                )}
            />
            <Column
                field="name"
                header="Descripción"
                headerStyle={headerStyle}
                style={{
                    ...cellStyle,
                    minWidth: "320px"
                }}
            />

            <Column
                header="Precio Público"
                headerStyle={headerStyle}
                style={{ width: "120px", textAlign: "center" }}
                body={(rowData) => (
                    <span style={{ fontSize: "12px" }}>
                        $ {number_format(rowData.price, 2)}
                    </span>
                )}
            />

            <Column
                header="Costo"
                headerStyle={headerStyle}
                style={{ width: "100px", textAlign: "center" }}
                body={(rowData) => (
                    <span style={{ fontSize: "12px" }}>
                        $ {number_format(rowData.production_cost, 2)}
                    </span>
                )}
            />

            <Column
                header="Válido a partir de"
                headerStyle={headerStyle}
                style={{ minWidth: "550px" }}
                body={(rowData) => (
                    <>
                        {rowData.listAgreementTestRanges?.length > 0 &&
                            rowData.listAgreementTestRanges.map((_range, _indRange) => (
                                <div
                                    key={_range.id_range}
                                    className="d-flex align-items-center"
                                    style={{
                                        gap: "12px",
                                        width: "100%",
                                        padding: "6px 0"
                                    }}
                                >
                                    {/* DESDE */}
                                    <div style={{ width: "90px" }}>
                                        <small
                                            className="d-block text-muted mb-1"
                                            style={labelStyle}
                                        >
                                            Desde
                                        </small>

                                        <Input
                                            type="number"
                                            autoComplete="off"
                                            name="min"
                                            value={_range.min}
                                            className={
                                                _range.alertClass === ""
                                                    ? "form-control form-control-sm input-air-primary AgreementPicker"
                                                    : "form-control form-control-sm input-air-primary text-danger AgreementPicker"
                                            }
                                            onChange={(e) =>
                                                handleChangeRange(
                                                    e,
                                                    _range.id_range,
                                                    rowData.is_curve,
                                                    rowData.id_exam,
                                                    rowData.id_profile,
                                                    null
                                                )
                                            }
                                        />
                                    </div>

                                    {/* HASTA */}
                                    <div style={{ width: "90px" }}>
                                        <small
                                            className="d-block text-muted mb-1"
                                            style={labelStyle}
                                        >
                                            Hasta
                                        </small>

                                        <Input
                                            type="number"
                                            autoComplete="off"
                                            name="max"
                                            value={_range.max}
                                            className={
                                                _range.alertClass === ""
                                                    ? "form-control form-control-sm input-air-primary AgreementPicker"
                                                    : "form-control form-control-sm input-air-primary text-danger AgreementPicker"
                                            }
                                            onChange={(e) =>
                                                handleChangeRange(
                                                    e,
                                                    _range.id_range,
                                                    rowData.is_curve,
                                                    rowData.id_exam,
                                                    rowData.id_profile,
                                                    null
                                                )
                                            }
                                        />
                                    </div>

                                    {/* DESCUENTO */}
                                    <div style={{ width: "180px" }}>
                                        <small
                                            className="d-block text-muted mb-1"
                                            style={labelStyle}
                                        >
                                            Aplicar descuento %
                                        </small>

                                        <InputGroup size="sm">
                                            <Input
                                                type="number"
                                                autoComplete="off"
                                                value={_range.percentage}
                                                className={
                                                    _range.alertClass === ""
                                                        ? ""
                                                        : "text-danger"
                                                }
                                                onChange={(e) =>
                                                    handleChangePercentage(
                                                        e,
                                                        _range.id_range,
                                                        rowData.id_exam,
                                                        rowData.id_profile,
                                                        null
                                                    )
                                                }
                                            />

                                            <InputGroupAddon
                                                addonType="append"
                                                onClick={() =>
                                                    handleDeleteRange(
                                                        _range.id_range,
                                                        _indRange,
                                                        rowData.id_exam,
                                                        rowData.id_profile,
                                                        null
                                                    )
                                                }
                                                style={{ cursor: "pointer" }}
                                            >
                                                <InputGroupText>
                                                    <i className="icofont icofont-ui-close text-danger"></i>
                                                </InputGroupText>
                                            </InputGroupAddon>
                                        </InputGroup>
                                    </div>

                                    {/* DESCUENTO EN PESOS */}
                                    <div
                                        style={{
                                            width: "110px",
                                            textAlign: "center"
                                        }}
                                    >
                                        <small
                                            className="d-block text-muted mb-1"
                                            style={labelStyle}
                                        >
                                            Descuento
                                        </small>

                                        <div style={amountStyle}>
                                            $
                                            {number_format(
                                                _range.discountPesos,
                                                2
                                            )}
                                        </div>
                                    </div>
                                    {/* VALOR VENTA */}
                                    {/* <div style={{ width: "180px" }}>
                                        <small
                                            className="d-block text-muted text-center mb-1"
                                            style={{ fontWeight: "600" }}
                                        >
                                            Valor Venta
                                        </small>

                                        <InputGroup size="sm">
                                            <InputGroupAddon addonType="prepend">
                                                <InputGroupText>$</InputGroupText>
                                            </InputGroupAddon>

                                            <Input
                                                type="number"
                                                autoComplete="off"
                                                value={_range.sale}
                                                className={
                                                    _range.alertClass === ""
                                                        ? ""
                                                        : "text-danger"
                                                }
                                                onChange={(e) =>
                                                    handleChangePrice(
                                                        e,
                                                        _range.id_range,
                                                        rowData.id_exam,
                                                        rowData.id_profile
                                                    )
                                                }
                                            />
                                        </InputGroup>
                                    </div> */}


                                    <div style={{ width: "180px" }}>
                                        <small
                                            className="d-block text-muted mb-1"
                                            style={labelStyle}
                                        >
                                            Valor Venta
                                        </small>

                                        <InputGroup size="sm">
                                            <InputGroupAddon addonType="prepend">
                                                <InputGroupText
                                                    style={{
                                                        fontWeight: 700,
                                                        fontSize: "12px",
                                                        color: "#0d3b59"
                                                    }}
                                                >
                                                    $
                                                </InputGroupText>
                                            </InputGroupAddon>

                                            <Input
                                                type="number"
                                                autoComplete="off"
                                                value={_range.sale}
                                                style={inputStyle}
                                                className={
                                                    _range.alertClass === ""
                                                        ? ""
                                                        : "text-danger"
                                                }
                                                onChange={(e) =>
                                                    handleChangePrice(
                                                        e,
                                                        _range.id_range,
                                                        rowData.id_exam,
                                                        rowData.id_profile
                                                    )
                                                }
                                            />
                                        </InputGroup>
                                    </div>
                                </div>
                            ))}
                    </>
                )}
            />

            {
                is_micro &&
                <Column
                    headerStyle={headerStyle} style={cellStyle}
                    header="Cantidad"
                    body={(rowData) => (
                        <Input
                            type="number"
                            autoComplete="off"
                            min={0}
                            value={rowData.cant_sample}
                            className="form-control form-control-sm input-air-primary"
                            onChange={(e) =>
                                handleCant(
                                    e,
                                    rowData.id_exam,
                                    rowData.id_profile
                                )
                            }
                        />
                    )}
                />
            }

            <Column
                header="Acciones"
                headerStyle={headerStyle}
                style={{ width: "90px", textAlign: "center" }}
                body={(rowData) => (
                    <Button
                        outline
                        color="danger"
                        className="btn btn-xs"
                        onClick={() =>
                            id_agreement > 0
                                ? handleTest(rowData.id_agreement_test)
                                : handleDeleteTestCreate(
                                    rowData.id_exam,
                                    rowData.id_profile
                                )
                        }
                    >
                        <i className="icofont icofont-bin"></i>
                    </Button>
                )}
            />
        </DataTable>
    )
}
